export default __webpack_public_path__ + "static/media/home1.3f7b0a0d.gif";